import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, TitleStrategy } from '@angular/router';
import { IsiDTCTheme } from '@config/theme';
import { PageTitleStrategy } from 'app/strategies/page-title.strategy';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { appGuidInterceptor } from 'app/interceptors/app-guid.interceptor';
import { completedAppInterceptor } from 'app/interceptors/completed-app.interceptor';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZonelessChangeDetection(),
        provideHttpClient(withFetch(), withInterceptors([appGuidInterceptor, completedAppInterceptor])),
        providePrimeNG({
            theme: {
                preset: IsiDTCTheme,
                options: {
                    darkModeSelector: '.isi-dtc-dark',
                },
            },
        }),
        provideRouter(routes),
        { provide: TitleStrategy, useClass: PageTitleStrategy },
        provideTranslateService({
            loader: provideTranslateHttpLoader({
                prefix: '/i18n/',
                suffix: '.json',
            }),
        }),
        MessageService,
    ],
};
